import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function authHeaders() {
  const token = localStorage.getItem("rav-token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const adminGet = (path) => axios.get(`${API}/admin${path}`, { headers: authHeaders() }).then((r) => r.data);
export const adminPost = (path, body) => axios.post(`${API}/admin${path}`, body, { headers: authHeaders() }).then((r) => r.data);
export const adminPut = (path, body) => axios.put(`${API}/admin${path}`, body, { headers: authHeaders() }).then((r) => r.data);
export const adminDel = (path) => axios.delete(`${API}/admin${path}`, { headers: authHeaders() }).then((r) => r.data);
